module.exports = __webpack_public_path__ + "img/file-check-fill.327a3c58.svg";